import * as React from "react";

function SvgDashboardCompany(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 21h8V9H3v12zm2-10h4v2H5v-2zm0 4h4v2H5v-2z"
        fill="#fff"
        fillOpacity={0.8}
      />
      <path
        d="M13 3h8v18h-8V3zm2 16h4v-2h-4v2zm0-4h4v-2h-4v2zm0-4h4V9h-4v2zm0-4h4V5h-4v2z"
        fill="#fff"
        fillOpacity={0.8}
      />
      <path
        d="M11 7h2v2h-2V7zM11 11h2v2h-2v-2zM11 15h2v2h-2v-2zM11 19h2v2h-2v-2z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  );
}

export default SvgDashboardCompany;
